import React, { useEffect } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { Avatar, Button, Divider, Drawer, Dropdown, Typography } from 'antd';
import PageRoutes from '../PageRoutes';
import AppMenu from '../Menu';

const MobileLayout = ({ viewModel }) => {
  const {
    user,
    accountMenu,
    showMenu,
    openMenu,
    closeMenu,
    colorBgContainer,
  } = viewModel;

  useEffect(() => {
    const handleOpenMenu = () => {
      openMenu();
    };

    window.addEventListener('open-mobile-app-menu', handleOpenMenu);

    return () => {
      window.removeEventListener('open-mobile-app-menu', handleOpenMenu);
    };
  }, [openMenu]);

  return (
    <>
      <Drawer
        title={user?.work_space?.name || 'Menu'}
        placement='left'
        width={280}
        onClose={closeMenu}
        open={showMenu}
        bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column' }}
      >
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <AppMenu onMenuClick={closeMenu} />
        </div>
        <Divider style={{ margin: 0 }} />
        <div style={{ padding: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography.Text strong>{user?.first_name || 'User'}</Typography.Text>
          <Button size='small' onClick={() => accountMenu?.onClick?.({ key: 'logout' })}>Đăng xuất</Button>
        </div>
      </Drawer>

      <div
        style={{
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          background: '#f5f5f5',
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 44,
            padding: 'calc(env(safe-area-inset-top, 0px) + 4px) 8px 4px',
            background: colorBgContainer,
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Button type='link' onClick={openMenu} style={{ paddingInline: 8, height: 32 }}>
            <MenuOutlined />
          </Button>

          <b style={{ lineHeight: 1.2, textAlign: 'center' }}>{user?.work_space?.name || 'Workspace'}</b>

          <Dropdown menu={accountMenu}>
            <Avatar size='small'>{user?.first_name || 'U'}</Avatar>
          </Dropdown>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            padding: 8,
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
          }}
        >
          <PageRoutes></PageRoutes>
        </div>
      </div>
    </>
  );
};

export default MobileLayout;